module.exports = __webpack_public_path__ + "media/images/3_2-b5c42d4b847d6ee6cd6afc5187b22477.png";